import { Edit } from "@mui/icons-material";
import { Box, Button, Grid, IconButton } from "@mui/material";
import { useContext, useState } from "react";
import { Global_CTX } from "../../contexts/global-ctx";
import { Admin_Service } from "../../services/admin/admin-service";
import { Search } from "../filters/Search";
import New_Item from "../new-item";
import { RUDTable } from "../Table/RUDTable";
import Create_Admin_Form from "./create-admin-form";
import EditAdmin from "./EditAdmin";

const initial_filter = {
    search: "",
    apply: 0,
};

export default function Admin_Page() {
    const { refetch_counter } = useContext(Global_CTX);
    const [filter, set_filter] = useState(initial_filter);
    const [open, setOpen] = useState(false);
    const [admin, setAdmin] = useState<any>();
    const handleEditAdmin = (row: any) => {
        setAdmin(row);
        setOpen(true);
    };

    return (
        <Box>
            <Box mb={2}>
                <New_Item title="Create Organization Admin">
                    <Create_Admin_Form />
                </New_Item>
            </Box>

            <Grid container p={2} gap={2}>
                <Grid item xs={12} lg={3}>
                    <Search filter={filter} setFilter={set_filter} />
                </Grid>

                <Grid item xs={12} lg={3}>
                    <Button
                        color="primary"
                        fullWidth
                        variant="contained"
                        onClick={() =>
                            set_filter({
                                ...filter,
                                apply: (filter.apply ?? 0) + 1,
                            })
                        }
                        style={{ height: "100%" }}
                        size="small"
                    >
                        {" "}
                        Search
                    </Button>
                </Grid>
            </Grid>

            <RUDTable
                storageKey="admins"
                updatingAgents={[refetch_counter, filter.apply]}
                getter={(page, limit) =>
                    Admin_Service.getAdmins(page, limit, {
                        search: filter.search ? filter.search : null,
                    })
                }
                deletor={(id, row) => {
                    return Admin_Service.deleteAdmin(row.username);
                }}
                editor={(id, updated_admin, row) => {
                    return Admin_Service.editAdmin(row.username, updated_admin);
                }}
                rowsPreprocessor={(row) => ({
                    ...row,
                    id: row.code,
                    deletionId: row.username,
                    organizationName: row?.organization?.name,
                    defaultOrganization: row?.organization,
                    organizationCode: row.organization.code,
                })}
                ops={{
                    read: "",
                    // edit: undefined,
                    // delete: undefined,
                }}
                readables={{
                    name: "Name",
                    username: "Username",
                    organizationName: "Organization",
                    organizationCode: "Organization Code",
                    Edit: "Edit",
                }}
                customCols={[
                    {
                        header: "Edit",
                        content: (row) => (
                            <IconButton
                                onClick={() => handleEditAdmin(row)}
                                size="small"
                            >
                                <Edit fontSize="small" />
                            </IconButton>
                        ),
                    },
                ]}
            />

            <EditAdmin row={admin} open={open} setOpen={setOpen} />
        </Box>
    );
}
